import Vue from 'vue';
export var defineHiddenProp = function (obj, key, val) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: false,
        configurable: true
    });
};
export function defineReactive(obj, key, value) {
    // @ts-ignore
    Vue.util.defineReactive(obj, key, value);
}
export function defineReactiveShallow(obj, key, value) {
    // @ts-ignore
    Vue.util.defineReactive(obj, key, value, undefined, true);
}
export function observable(data, keys) {
    if (keys === void 0) { keys = []; }
    keys.forEach(function (k) {
        defineReactiveShallow(data, k, data[k]);
    });
}
export function observableShallow(obj, keys) {
    if (keys === void 0) { keys = []; }
    if (Array.isArray(obj)) {
        var array = Array.isArray(obj) ? obj : [obj];
        array.forEach(function (item) {
            observable(item, keys);
        });
        return obj;
    }
    else if (typeof obj === 'object' && obj !== null) {
        observable(obj, keys);
        return obj;
    }
}
export var noop = function () { };
